import { RootState } from "../../../store";
import { MultiFilters } from "../../utils/types/resourceExplorer";
import { resourceExplorerStateSelector } from "../resourceExplorerStateSelector";

export const resourceExplorerAppliedFiltersSelector = (
  state: RootState,
): MultiFilters => {
  return resourceExplorerStateSelector(state).filters;
};
